import { render, staticRenderFns } from "./NoContentCorrespondencia.vue?vue&type=template&id=1c149b02&"
import script from "./NoContentCorrespondencia.vue?vue&type=script&lang=js&"
export * from "./NoContentCorrespondencia.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports